import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import Loading from "../../../../components/Loading";

export const SelectRestaurants = ({
    visible,
    onClose,
    onSave,
    onChangeRestaurants,
    restaurants,
    formikValues,
    isAllChecked,
    handleSelectAll,
    isLoading,
    restaurantName
}) => {
    const { t } = useTranslation();
    return (
        <Modal
            isOpen={visible}
            onRequestClose={onClose}
            closeTimeoutMS={200}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
            className="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full sm:max-w-2xl sm:mx-auto"
            style={{
                overlay: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(107, 114, 128, 0.75)",
                },
                content: { overflow: "hidden" },
            }}
        >
            <Loading loading={isLoading}>
                {restaurants.length === 0 ? (
                    <div className="h-40 px-12 p-8 flex flex-col gap-10 items-center">
                        <div className="font-bold text-xl">
                            {t("List of restaurants is empty")}
                        </div>
                        <button
                            type="button"
                            className="inline-flex justify-center py-2 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                            onClick={onClose}
                        >
                            {t("Close")}
                        </button>
                    </div>
                ) : (
                    <>
                        <div className="px-12 pt-10 ">
                            <div className="font-bold text-xl">
                                {t("Add to Stores")}
                            </div>

                            <div className="bg-white h-56 overflow-y-auto">
                                <div className="flex items-center pl-5 mt-4 col-span-2 border-none focus:ring-gray-200 h-9 focus:border-gray-100 bg-gray-50 w-full shadow-sm sm:text-sm rounded-md">
                                    <input
                                        type="checkbox"
                                        id="all_locations"
                                        name="All Locations"
                                        onChange={handleSelectAll}
                                        className="mr-5"
                                        checked={isAllChecked}
                                    />
                                    <label
                                        htmlFor="all_locations"
                                        className="text-md font-bold"
                                    >
                                        {t("All Locations")}
                                    </label>
                                </div>

                                {restaurants.map(({ id, name }) => (
                                    <div
                                        className="flex items-center pl-5 col-span-2 mt-1 border-none focus:ring-gray-200 h-9 focus:border-gray-100 bg-gray-50 w-full shadow-sm sm:text-sm rounded-md"
                                        key={name}
                                    >
                                        <input
                                            type="checkbox"
                                            id={id}
                                            name={restaurantName}
                                            onChange={onChangeRestaurants}
                                            value={id}
                                            className="mr-5"
                                            checked={formikValues.includes(
                                                String(id)
                                            )}
                                        />
                                        <label
                                            htmlFor={id}
                                            className="text-md font-bold"
                                        >
                                            {name}
                                        </label>
                                    </div>
                                ))}

                                {/*<div className="flex items-center pl-5 mt-4 col-span-2 border-none focus:ring-gray-200 h-9 focus:border-gray-100 bg-gray-50 w-full shadow-sm sm:text-sm rounded-md">*/}
                                {/*    <input*/}
                                {/*        type="checkbox"*/}
                                {/*        id="all_future_locations"*/}
                                {/*        name="All Future Locations"*/}
                                {/*        onChange={handleSelectAllFutureLocations}*/}
                                {/*        className="mr-5"*/}
                                {/*        checked={isCheckAllFutureLocations}*/}
                                {/*    />*/}
                                {/*    <label*/}
                                {/*        htmlFor="all_future_locations"*/}
                                {/*        className="text-md font-bold"*/}
                                {/*    >*/}
                                {/*        {t("All Future Locations")}*/}
                                {/*    </label>*/}
                                {/*</div>*/}
                            </div>
                        </div>

                        <div className="py-5 px-12 text-right">
                            <button
                                type="button"
                                className="inline-flex justify-center mr-2 py-2 px-7 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-300 hover:bg-gray-400 activ:bg-gray-500 focus:outline-none"
                                onClick={onClose}
                            >
                                {t("Cancel")}
                            </button>
                            <button
                                onClick={onSave}
                                type="submit"
                                className="inline-flex justify-center py-2 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                            >
                                {t("Save")}
                            </button>
                        </div>
                    </>
                )}
            </Loading>
        </Modal>
    );
};
